// assets/wu-card.js
;(async function(){
  // Prevent duplicate initialization
  if (window.wuCardInitialized) {
    console.log("⚠️ wu-card.js already initialized, skipping");
    return;
  }
  window.wuCardInitialized = true;
  
  console.log("🔧 wu-card.js loaded");

  // Load BodyPix
  const net = await bodyPix.load({
    architecture: "MobileNetV1",
    outputStride: 16,
    multiplier: 0.75,
    quantBytes: 2,
  });
  console.log("✅ bodyPix model ready");

  function init(){
    console.log("📦 init()");
    const wuName  = sessionStorage.getItem("wuName");
    const userLoc = sessionStorage.getItem("location");

    const noSessionEl = document.getElementById("no-session");
    if (!wuName || !userLoc) {
      if (noSessionEl) noSessionEl.style.display = "block";
      document.querySelectorAll(".wu-step").forEach(el => el.style.display = "none");
      return;
    }
    const safeWuName  = wuName;
    const safeUserLoc = userLoc;

    // Steps
    const step1 = document.querySelector(".wu-step-1");
    const step2 = document.querySelector(".wu-step-2");
    const step3 = document.querySelector(".wu-step-3");
    const step4 = document.querySelector(".wu-step-4");

    // Controls
    const uploadInput  = document.getElementById("upload-photo");
    const uploadBtn    = document.getElementById("upload-photo-btn");
    const continueBtn  = document.getElementById("continue-to-customize");
    const takeBtn      = document.getElementById("take-photo");
    const cameraWrap   = document.getElementById("camera-capture");
    const captureBtn   = document.getElementById("capture-photo");
    const videoEl      = document.getElementById("camera-video");

    // Canvases
    const canvas      = document.getElementById("photo-canvas");
    const ctx         = canvas.getContext("2d", { willReadFrequently: true });
    const finalCanvas = document.getElementById("final-canvas");
    const fctx        = finalCanvas.getContext("2d", { willReadFrequently: true });

    const saveLink     = document.getElementById("save-card");
    const startOverBtn = document.getElementById("start-over");
    const completeBtn  = document.getElementById("complete-card");

    // Sizing
    const CANVAS_W = 450, CANVAS_H = 600;
    canvas.width = CANVAS_W; canvas.height = CANVAS_H;

    // Initial visibility
    canvas.style.display = "none";
    videoEl.style.display = "none";
    captureBtn.style.display = "none";
    if (cameraWrap) cameraWrap.style.display = "none";

    // Assets
    const backgrounds = {
      gold: "https://cdn.shopify.com/s/files/1/0588/2704/7117/files/Gold_BG.webp?v=1752591498",
      eyes: "https://cdn.shopify.com/s/files/1/0588/2704/7117/files/Eyes_BG.webp?v=1752591498",
      ship: "https://cdn.shopify.com/s/files/1/0588/2704/7117/files/Ship_BG.webp?v=1752591498",
    };
    const nameplates = {
      gold: "https://cdn.shopify.com/s/files/1/0588/2704/7117/files/Gold_Nameplate.webp?v=1752591498",
      eyes: "https://cdn.shopify.com/s/files/1/0588/2704/7117/files/Eyes_Nameplate.webp?v=1752591498",
      ship: "https://cdn.shopify.com/s/files/1/0588/2704/7117/files/Ship_Nameplate.png?v=1756409051",
    };
    const borders = {
      gold:   "https://cdn.shopify.com/s/files/1/0588/2704/7117/files/Gold_Border.webp?v=1752591498",
      silver: "https://cdn.shopify.com/s/files/1/0588/2704/7117/files/Silver_Border.webp?v=1752591498",
      black:  "https://cdn.shopify.com/s/files/1/0588/2704/7117/files/Black_Border.webp?v=1752591498",
    };
    const editionNumbers = { gold: "001", eyes: "002", ship: "003" };
    const numberBgUrl    = "https://cdn.shopify.com/s/files/1/0588/2704/7117/files/Card_Number_BG.webp?v=1752591498";
    let currentArt = "gold";
    let currentBorder = "silver";  // Track current border too

    if (window.wuCardDynamic?.collab?.bg) {
      backgrounds.collab    = window.wuCardDynamic.collab.bg;
      if (window.wuCardDynamic.collab.plate) {
        nameplates.collab   = window.wuCardDynamic.collab.plate;
      }
      editionNumbers.collab = window.wuCardDynamic.collab.num || "004";
    }

    // Overlay assets
    const bgImg       = new Image();
    const plateImg    = new Image();
    const brdImg      = new Image();
    const numberBgImg = new Image();
    [bgImg, plateImg, brdImg, numberBgImg].forEach(img => img.crossOrigin = "anonymous");

    // 🔒 Face buffer canvas (source of truth)
    let faceBuffer = document.createElement("canvas");
    let faceCtx    = faceBuffer.getContext("2d", { willReadFrequently: true });

    // State
    let hasFace = false;
    let assetsReady = false;
    let needsRender = false;
    let loadToken = 0;         // guards stale image loads
    let uiLocked = false;      // block interactions while loading
    let assetsEverLoaded = false; // track if we've ever successfully loaded assets

    // Pan/zoom state with clamps
    let scale = 1, offsetX = 0, offsetY = 0, dragging = false, startX = 0, startY = 0;
    let minScale = 0.2, maxScale = 6;

    function sanitizeTransform(){
      if (!Number.isFinite(scale) || scale <= 0) scale = 1;
      if (!Number.isFinite(offsetX)) offsetX = 0;
      if (!Number.isFinite(offsetY)) offsetY = 0;
      scale = Math.min(maxScale, Math.max(minScale, scale));
      
      // Debug log to track state changes
      if (window.wuCardDebug) {
        console.log("Transform sanitized:", { scale, offsetX, offsetY, minScale, maxScale });
      }
    }

    function scheduleRender(){
      if (needsRender) return;
      needsRender = true;
      requestAnimationFrame(() => {
        needsRender = false;
        renderAll();
      });
    }

    function preloadAssets(art, brd, cb){
      // If assets already loaded with same params, skip reload
      if (assetsEverLoaded && currentArt === art && currentBorder === brd && assetsReady) {
        console.log("♻️ Assets already loaded for this config, skipping");
        cb?.();
        return;
      }
      
      console.log("🔄 Loading assets:", { art, brd });
      currentArt = art;
      currentBorder = brd;  // Track the border too
      uiLocked = true;
      assetsReady = false;

      const token = ++loadToken;
      let loaded = 0;
      const all = [bgImg, plateImg, brdImg, numberBgImg];
      bgImg.src       = backgrounds[art];
      plateImg.src    = nameplates[art];
      brdImg.src      = borders[brd];
      numberBgImg.src = numberBgUrl;

      const done = () => {
        if (++loaded === all.length) {
          if (token !== loadToken) return; // ignore stale loads
          assetsReady = true;
          assetsEverLoaded = true;
          uiLocked = false;
          console.log("✅ Assets ready");
          cb?.();
        }
      };

      all.forEach(img => {
        if (img.complete && img.naturalWidth) done();
        else {
          img.onload  = done;
          img.onerror = (e) => { console.error("Image failed:", img.src, e); done(); };
        }
      });
    }

    // Helpers: set faceBuffer from a canvas (segmented tmp) - Enhanced with debugging
    function setFaceFromCanvas(sourceCanvas){
      if (!sourceCanvas || !sourceCanvas.width || !sourceCanvas.height) {
        console.warn("❌ Invalid source canvas for setFaceFromCanvas");
        return;
      }
      
      console.log(`📐 Setting face from canvas: ${sourceCanvas.width}x${sourceCanvas.height}`);
      
      faceBuffer.width  = sourceCanvas.width;
      faceBuffer.height = sourceCanvas.height;
      faceCtx.clearRect(0, 0, faceBuffer.width, faceBuffer.height);
      faceCtx.drawImage(sourceCanvas, 0, 0);
      hasFace = true;

      // Fit into card
      const rW = CANVAS_W / faceBuffer.width;
      const rH = CANVAS_H / faceBuffer.height;
      const fit = Math.min(rW, rH);
      
      console.log(`📏 Calculated fit ratio: ${fit} (rW: ${rW}, rH: ${rH})`);
      
      scale   = fit;
      minScale = fit * 0.35;
      maxScale = fit * 5;
      offsetX = (CANVAS_W - faceBuffer.width  * scale) / 2;
      offsetY = (CANVAS_H - faceBuffer.height * scale) / 2;
      
      console.log(`🎯 Transform set - scale: ${scale}, offset: (${offsetX}, ${offsetY})`);
      console.log(`📊 Scale bounds - min: ${minScale}, max: ${maxScale}`);
    }

    // ======= Drawing - Fixed to prevent white canvas =======
    function drawFace(ctxTarget = ctx){
      console.log("🎨 Drawing face...", {
        hasFace,
        assetsReady,
        scale,
        offsetX,
        offsetY,
        faceBufferSize: hasFace ? `${faceBuffer.width}x${faceBuffer.height}` : 'none'
      });

      // Always paint neutral background first
      ctxTarget.save();
      ctxTarget.setTransform(1,0,0,1,0,0);
      ctxTarget.clearRect(0,0,CANVAS_W,CANVAS_H);
      
      // CRITICAL FIX: Use a light gray instead of white when no background is ready
      // This prevents the jarring white flash
      ctxTarget.fillStyle = assetsReady ? "#fff" : "#f0f0f0";
      ctxTarget.fillRect(0,0,CANVAS_W,CANVAS_H);
      ctxTarget.restore();

      // BG if ready - only draw if assets are actually loaded
      if (assetsReady && bgImg.complete && bgImg.naturalWidth) {
        console.log("🖼️ Drawing background image");
        try { 
          ctxTarget.drawImage(bgImg, 0,0, CANVAS_W, CANVAS_H); 
        } catch(e){ 
          console.error("❌ Background draw error:", e);
        }
      } else {
        console.log("⏳ Background not ready yet, showing placeholder");
      }

      // Face - only draw if we have a valid face
      if (hasFace && faceBuffer.width > 0 && faceBuffer.height > 0){
        const fw = faceBuffer.width  * scale;
        const fh = faceBuffer.height * scale;
        
        console.log(`👤 Drawing face: size ${fw}x${fh} at (${offsetX}, ${offsetY})`);
        
        if (Number.isFinite(fw) && Number.isFinite(fh) && fw > 0 && fh > 0 && 
            Number.isFinite(offsetX) && Number.isFinite(offsetY)){
          try { 
            ctxTarget.drawImage(faceBuffer, offsetX, offsetY, fw, fh); 
            console.log("✅ Face drawn successfully");
          } catch(e){ 
            console.error("❌ Face draw error:", e);
          }
        } else {
          console.error("❌ Invalid face dimensions or position:", { fw, fh, offsetX, offsetY });
        }
      } else if (hasFace) {
        console.log("❌ Face buffer has invalid dimensions");
      }
    }

    function drawOverlay(ctxTarget = ctx){
      // CRITICAL FIX: Only draw overlay if assets are ready
      if (!assetsReady) {
        console.log("⏳ Skipping overlay - assets not ready");
        return;
      }

      // Guard against zero/NaN sizes from missing images
      const pW = plateImg.naturalWidth  || CANVAS_W;
      const pH = plateImg.naturalHeight || Math.round(CANVAS_W * 0.25);
      const aspectP = pH / pW;

      // Nameplate
      const pw = CANVAS_W;
      const ph = Math.max(1, pw * aspectP);
      const py = CANVAS_H - ph - 20;
      
      if (plateImg.complete && plateImg.naturalWidth) {
        try { ctxTarget.drawImage(plateImg, 0, py, pw, ph); } catch(e){ console.error("Plate draw error:", e); }
      }

      // Text colors
      const fillCol   = document.querySelector("input[name='name-color']:checked")?.value || "#000";
      const strokeCol = fillCol === "#000" ? "#fff" : "#000";

      // Plate text area
      const textAreaX = 50;
      const textAreaW = pw - (textAreaX * 2);
      const textAreaY = py + (ph * 0.65);
      const textAreaH = ph * 0.35;

      const NAME_TXT = (safeWuName || "").toUpperCase();
      const LOC_TXT  = (safeUserLoc || "").toUpperCase();

      // Start sizes
      let nameFontSize = 28;
      let locFontSize  = 20;

      // Fit name
      ctxTarget.font = `bold ${nameFontSize}px 'Archivo Expanded Black', sans-serif`;
      let nameWidth = ctxTarget.measureText(NAME_TXT).width;
      while (nameWidth > textAreaW && nameFontSize > 12) {
        nameFontSize--;
        ctxTarget.font = `bold ${nameFontSize}px 'Archivo Expanded Black', sans-serif`;
        nameWidth = ctxTarget.measureText(NAME_TXT).width;
      }

      // Fit location
      locFontSize = Math.min(locFontSize, Math.floor(nameFontSize * 0.7));
      ctxTarget.font = `bold ${locFontSize}px 'Archivo Expanded Black', sans-serif`;
      let locWidth = ctxTarget.measureText(LOC_TXT).width;
      while (locWidth > textAreaW && locFontSize > 10) {
        locFontSize--;
        ctxTarget.font = `bold ${locFontSize}px 'Archivo Expanded Black', sans-serif`;
        locWidth = ctxTarget.measureText(LOC_TXT).width;
      }

      // Vertical positions
      const lineGap = 5;
      const totalTextHeight = nameFontSize + lineGap + locFontSize;
      const startY = textAreaY + (textAreaH - totalTextHeight) / 2;

      ctxTarget.save();
      ctxTarget.textAlign = "center";
      ctxTarget.textBaseline = "top";

      // Name
      ctxTarget.font = `bold ${nameFontSize}px 'Archivo Expanded Black', sans-serif`;
      ctxTarget.lineWidth = 2;
      ctxTarget.strokeStyle = strokeCol;
      ctxTarget.fillStyle = fillCol;
      if (Number.isFinite(startY)) {
        ctxTarget.strokeText(NAME_TXT, CANVAS_W/2, startY);
        ctxTarget.fillText(NAME_TXT, CANVAS_W/2, startY);
      }

      // Location
      ctxTarget.font = `bold ${locFontSize}px 'Archivo Expanded Black', sans-serif`;
      ctxTarget.lineWidth = 1.5;
      if (Number.isFinite(startY)) {
        ctxTarget.strokeText(LOC_TXT, CANVAS_W/2, startY + nameFontSize + lineGap);
        ctxTarget.fillText(LOC_TXT, CANVAS_W/2, startY + nameFontSize + lineGap);
      }

      ctxTarget.restore();

      // Border
      if (brdImg.complete && brdImg.naturalWidth) {
        try { ctxTarget.drawImage(brdImg, 0, 0, CANVAS_W, CANVAS_H); } catch(e){ console.error("Border draw error:", e); }
      }

      // Edition badge
      const nbW = 100, nbH = 50, nbY = 60, extra = 10;
      const nbX = CANVAS_W - nbW + extra;
      
      if (numberBgImg.complete && numberBgImg.naturalWidth) {
        try { ctxTarget.drawImage(numberBgImg, nbX, nbY, nbW, nbH); } catch(e){ console.error("Number BG draw error:", e); }
      }

      ctxTarget.save();
      ctxTarget.fillStyle = "#000";
      ctxTarget.font = "bold 16px 'Archivo Expanded Black', sans-serif";
      ctxTarget.textAlign = "left";
      ctxTarget.textBaseline = "middle";
      ctxTarget.fillText(editionNumbers[currentArt] || "", nbX + 40, nbY + nbH/2);
      ctxTarget.restore();
    }

    function renderAll(){
      // CRITICAL FIX: Don't render if we're still loading
      if (uiLocked && !assetsReady) {
        console.log("🔒 Skipping render - assets still loading");
        return;
      }
      
      // Additional safety check - don't lose face data
      if (!hasFace && faceBuffer.width > 0) {
        console.warn("⚠️ Face flag was false but buffer exists - recovering");
        hasFace = true;
      }
      
      try {
        sanitizeTransform();
        drawFace(ctx);
        drawOverlay(ctx);
      } catch (e){
        console.error("renderAll error:", e);
      }
    }

    // ======= Camera flow =======
    function stopStream(){
      const s = videoEl?.srcObject;
      if (s) s.getTracks().forEach(t => t.stop());
      videoEl.srcObject = null;
    }
    window.addEventListener("beforeunload", stopStream);

    takeBtn?.addEventListener("click", async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        videoEl.srcObject = stream;

        if (videoEl.readyState < 2) {
          await new Promise(res => videoEl.addEventListener('loadedmetadata', res, { once: true }));
        }

        if (cameraWrap) cameraWrap.style.display = "block";
        videoEl.style.display = "block";
        captureBtn.style.display = "inline-block";
        takeBtn.style.display = "none";
      } catch (err) {
        console.error("❌ camera error:", err);
        alert("Unable to access your camera.");
      }
    });

    // ======= FIXED Camera capture flow =======
    captureBtn?.addEventListener("click", async () => {
      if (!videoEl.videoWidth || !videoEl.videoHeight) return;

      try {
        // 1. Snapshot current frame
        const tmp = document.createElement("canvas");
        tmp.width  = videoEl.videoWidth;
        tmp.height = videoEl.videoHeight;
        const tmpCtx = tmp.getContext("2d");
  tmpCtx.translate(tmp.width, 0);
tmpCtx.scale(-1, 1);
tmpCtx.drawImage(videoEl, 0, 0, tmp.width, tmp.height);

        // 2. Stop camera stream
        stopStream();
        videoEl.style.display    = "none";
        captureBtn.style.display = "none";
        if (cameraWrap) cameraWrap.style.display = "none";

        // 3. Run segmentation
        console.log("🔍 Running segmentation...");
        const seg = await net.segmentPerson(tmp);
        
        // 4. Create segmented result with better background handling
        const segmentedCanvas = document.createElement("canvas");
        segmentedCanvas.width = tmp.width;
        segmentedCanvas.height = tmp.height;
        const segCtx = segmentedCanvas.getContext("2d");
        
        // Clear with transparent background
        segCtx.clearRect(0, 0, segmentedCanvas.width, segmentedCanvas.height);
        
        // Get original image data
        const originalImageData = tmpCtx.getImageData(0, 0, tmp.width, tmp.height);
        const segmentedImageData = segCtx.createImageData(tmp.width, tmp.height);
        
        // Copy pixels where person is detected, make others transparent
        for (let i = 0; i < seg.data.length; i++) {
          const pixelIndex = i * 4;
          if (seg.data[i]) { // is person
            segmentedImageData.data[pixelIndex] = originalImageData.data[pixelIndex];         // R
            segmentedImageData.data[pixelIndex + 1] = originalImageData.data[pixelIndex + 1]; // G
            segmentedImageData.data[pixelIndex + 2] = originalImageData.data[pixelIndex + 2]; // B
            segmentedImageData.data[pixelIndex + 3] = originalImageData.data[pixelIndex + 3]; // A
          } else {
            // Make background transparent
            segmentedImageData.data[pixelIndex + 3] = 0; // Transparent
          }
        }
        
        segCtx.putImageData(segmentedImageData, 0, 0);
        console.log("✅ Segmentation complete");

        // 5. Store the result into faceBuffer
        setFaceFromCanvas(segmentedCanvas);

        // 6. Show Step 2 and preload
        step1.style.display  = "none";
        step2.style.display  = "block";
        canvas.style.display = "block";
        
        // CRITICAL FIX: Wait for assets before rendering
        console.log("🎨 Loading assets...");
        preloadAssets("gold", "silver", () => {
          console.log("🖼️ Assets loaded, rendering...");
          // Now it's safe to render
          renderAll();
        });
        
      } catch (error) {
        console.error("❌ Camera capture error:", error);
        alert("Error processing camera capture. Please try again.");
        
        // Reset to step 1 on error
        step2.style.display = "none";
        step1.style.display = "block";
        canvas.style.display = "none";
      }
    });

    // ======= Upload flow (debounced click kept) =======
    let isUploading = false;
    uploadBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (isUploading) return;

      if (uploadInput) {
        uploadInput.value = '';
        setTimeout(() => {
          isUploading = true;
          uploadInput.click();
          setTimeout(() => { isUploading = false; }, 500);
        }, 10);
      }
    });

    uploadInput?.addEventListener("change", async e => {
      const file = e.target.files?.[0];
      if (!file) return;
      e.stopPropagation();

      try {
        const raw = new Image();
        raw.crossOrigin = "anonymous";
        
        // Create object URL for the image
        const imageUrl = URL.createObjectURL(file);
        
        // Load image with error handling
        await new Promise((resolve, reject) => {
          raw.onload = resolve;
          raw.onerror = reject;
          raw.src = imageUrl;
        });

        // Resize if image is too large (iOS photos can be huge)
        const MAX_SIZE = 1920;
        let width = raw.width;
        let height = raw.height;
        
        if (width > MAX_SIZE || height > MAX_SIZE) {
          console.log(`📐 Resizing large image: ${width}x${height}`);
          if (width > height) {
            height = (height / width) * MAX_SIZE;
            width = MAX_SIZE;
          } else {
            width = (width / height) * MAX_SIZE;
            height = MAX_SIZE;
          }
        }

        // Create a canvas for the potentially resized image
        const resizedCanvas = document.createElement("canvas");
        resizedCanvas.width = width;
        resizedCanvas.height = height;
        const resizedCtx = resizedCanvas.getContext("2d");
        resizedCtx.drawImage(raw, 0, 0, width, height);

        // Clean up object URL
        URL.revokeObjectURL(imageUrl);

        // Run segmentation on resized image
        console.log("🔍 Running segmentation on uploaded image...");
        const seg = await net.segmentPerson(resizedCanvas);
        
        // Create segmented result
        const segmentedCanvas = document.createElement("canvas");
        segmentedCanvas.width = width;
        segmentedCanvas.height = height;
        const segCtx = segmentedCanvas.getContext("2d");
        
        // Get image data from resized canvas
        const imageData = resizedCtx.getImageData(0, 0, width, height);
        const segmentedData = segCtx.createImageData(width, height);
        
        // Apply segmentation mask
        for (let i = 0; i < seg.data.length; i++) {
          const pixelIndex = i * 4;
          if (seg.data[i]) {
            segmentedData.data[pixelIndex] = imageData.data[pixelIndex];
            segmentedData.data[pixelIndex + 1] = imageData.data[pixelIndex + 1];
            segmentedData.data[pixelIndex + 2] = imageData.data[pixelIndex + 2];
            segmentedData.data[pixelIndex + 3] = imageData.data[pixelIndex + 3];
          } else {
            segmentedData.data[pixelIndex + 3] = 0; // Transparent
          }
        }
        
        segCtx.putImageData(segmentedData, 0, 0);
        console.log("✅ Segmentation complete");

        setFaceFromCanvas(segmentedCanvas);

        step1.style.display  = "none";
        step2.style.display  = "block";
        canvas.style.display = "block";
        
        // CRITICAL FIX: Wait for assets before rendering
        preloadAssets("gold", "silver", () => {
          renderAll();
        });
        
      } catch (error) {
        console.error("❌ Upload processing error:", error);
        alert("Error processing image. Please try a different photo or take a new one.");
        
        // Reset input
        uploadInput.value = '';
      }
    });

    // ======= Pointer helpers (robust against CSS scaling) =======
    function getLocalPos(e){
      const rect = canvas.getBoundingClientRect();
      const xCss = (e.clientX ?? (e.touches?.[0]?.clientX ?? 0)) - rect.left;
      const yCss = (e.clientY ?? (e.touches?.[0]?.clientY ?? 0)) - rect.top;
      // Map CSS pixels → canvas pixels
      const x = xCss * (canvas.width / rect.width);
      const y = yCss * (canvas.height / rect.height);
      return { x, y };
    }

    // ======= Pan / Zoom (clamped + RAF + lock during load) =======
    canvas.addEventListener("pointerdown", e => {
      if (uiLocked) return;
      canvas.setPointerCapture(e.pointerId);
      const { x, y } = getLocalPos(e);
      dragging = true;
      startX = x - offsetX;
      startY = y - offsetY;
    });

    canvas.addEventListener("pointermove", e => {
      if (uiLocked || !dragging) return;
      const { x, y } = getLocalPos(e);
      offsetX = x - startX;
      offsetY = y - startY;
      scheduleRender();
    });

    window.addEventListener("pointerup", () => { dragging = false; });
    canvas.addEventListener("pointerleave", () => { dragging = false; });

    document.getElementById("zoom-in")?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (uiLocked) return;
      const newScale = Math.min(maxScale, scale * 1.1);
      const k = newScale / scale;
      const cx = CANVAS_W/2, cy = CANVAS_H/2;
      offsetX = cx - (cx - offsetX) * k;
      offsetY = cy - (cy - offsetY) * k;
      scale = newScale;
      scheduleRender();
    });

    document.getElementById("zoom-out")?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (uiLocked) return;
      const newScale = Math.max(minScale, scale / 1.1);
      const k = newScale / scale;
      const cx = CANVAS_W/2, cy = CANVAS_H/2;
      offsetX = cx - (cx - offsetX) * k;
      offsetY = cy - (cy - offsetY) * k;
      scale = newScale;
      scheduleRender();
    });

    canvas.addEventListener("wheel", (e) => {
      if (uiLocked) return;
      e.preventDefault();
      const { x: mx, y: my } = getLocalPos(e);
      const factor = e.deltaY < 0 ? 1.08 : 0.92;
      const newScale = Math.max(minScale, Math.min(maxScale, scale * factor));
      const k = newScale / scale;

      offsetX = mx - (mx - offsetX) * k;
      offsetY = my - (my - offsetY) * k;

      scale = newScale;
      scheduleRender();
    }, { passive:false });

    // ======= Continue → Step 3 (move canvas + listeners) =======
    // Track if listeners have been added to prevent duplicates
    let step3ListenersAdded = false;
    
    continueBtn?.addEventListener("click", () => {
      const preview = step3.querySelector(".preview");
      if (preview && !preview.contains(canvas)) preview.appendChild(canvas);

      step2.style.display = "none";
      step3.style.display = "block";
      canvas.style.display = "block";

      // Only add listeners once to prevent duplicate handlers
      if (!step3ListenersAdded) {
        step3ListenersAdded = true;
        
        document.querySelectorAll("input[name='artwork']")?.forEach(r => {
          r.addEventListener("change", e => {
            const art = e.target.value;
            const brd = document.querySelector("input[name='border']:checked")?.value || currentBorder;
            preloadAssets(art, brd, () => renderAll());
          });
        });
        document.querySelectorAll("input[name='border']")?.forEach(r => {
          r.addEventListener("change", e => {
            const brd = e.target.value;
            const art = document.querySelector("input[name='artwork']:checked")?.value || currentArt;
            preloadAssets(art, brd, () => renderAll());
          });
        });
        document.querySelectorAll("input[name='name-color']")?.forEach(r => {
          r.addEventListener("change", () => renderAll());
        });
      }

      // CRITICAL FIX: Only render if assets are ready
      if (assetsReady) {
        renderAll();
      } else {
        console.log("⏳ Waiting for assets before rendering on step 3");
      }
    });

    // ======= Complete / Save / Start Over =======
    completeBtn?.addEventListener("click", () => {
      // CRITICAL FIX: Only render final if assets are ready
      if (assetsReady) {
        fctx.clearRect(0,0,finalCanvas.width,finalCanvas.height);
        drawFace(fctx);
        drawOverlay(fctx);
      }

      const fileName = (safeWuName || "Wu-Card")
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^a-zA-Z0-9\-]/g, '')
        + "-Wu-Card.png";

      try {
        const dataUrl = finalCanvas.toDataURL("image/png");
        saveLink.href = dataUrl;
        saveLink.download = fileName;
      } catch(e) {
        console.warn("toDataURL failed:", e);
        saveLink.removeAttribute("href");
      }

      step3.style.display = "none";
      step4.style.display = "block";
    });

    startOverBtn?.addEventListener("click", () => {
      // Simple page refresh - cleanest way to reset everything
      window.location.reload();
    });
  }

  // Only init once, even if DOMContentLoaded fires multiple times
  let initialized = false;
  function runInit() {
    if (initialized) return;
    initialized = true;
    init();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInit, { once: true });
  } else {
    runInit();
  }
})();